export default {
    visibility: {
        threshold: 0.2,
        triggerOnce: true,
    },
};
